export const bonusPhaseTypeEnum = {
  BUNDLES: 'bundles',
  POINTS: 'points',
  DAILY: 'daily',
};
